import { useRef } from 'react';
import { useTheme } from '@emotion/react';
import { useFrame } from '@react-three/fiber';
import { Mesh } from 'three';

export default function ViewerLoading() {
  const theme = useTheme();
  const meshRef = useRef<Mesh>(null!);

  useFrame((state, delta) => {
    meshRef.current.rotation.z -= delta * 3;
  });

  return (
    <>
      <color attach='background' args={[theme.backgroundColor.base]} />
      <directionalLight
        castShadow
        position={[0, 8, 8]}
        intensity={0.6}
        color={'#ffffff'}
      />
      <mesh ref={meshRef} scale={0.1} position={[0, 0.5, 0]}>
        <ringGeometry args={[3.5, 4, 23, 8, 1.8, 4.3]} />
        <meshStandardMaterial color={theme.themeColor.main_1} />
      </mesh>
    </>
  );
}
